<div *ngIf="!isTeethWhiteningResult">
  <div class="next-card-header">
    <div
      class="next-card-top d-flex align-items-center justify-content-between"
    >
      <div class="card-content">
        <h4 *ngIf="!isBupaFlow">Find A Dentist Near You</h4>
        <h4 *ngIf="isBupaFlow">Find A Bupa Dentist Near You</h4>

        <!-- <h4>Request A Dental Appointment</h4> -->
        <p>
          Secure your next appointment with ease and improve your oral health.
        </p>
        <!-- <p>Secure your next appointment with ease & enhance your smile.</p> -->
        <button
          class="btn btn-primary btn-rounded-corner btn-icon-right btn-xs mt-2"
          (click)="onBookNow()"
        >
          Book Now <i class="icon_arrow icon-right-arrow"></i>
        </button>
      </div>
      <div class="card-image">
        <img
          src="assets/images/appointment-card.png"
          class="img-fluid d-none d-sm-block"
          alt=""
        />
        <img
          src="assets/images/appointment-card-mobile.png"
          class="img-fluid d-block d-sm-none"
          alt=""
        />
      </div>
    </div>
    <div class="next-card-bottom">
      <a
        href="javascript:void(0)"
        class="d-flex align-items-center justify-content-center"
        (click)="isExpand = !isExpand"
        ><b class="mr-1">Learn More</b> About Requesting An Appointment
        <i
          class="ml-2"
          [ngClass]="!isExpand ? 'sh-angle-down' : 'sh-angle-up'"
        ></i
      ></a>
    </div>
  </div>
  <div class="next-card-body" *ngIf="isExpand">
    <h4>All Benefits</h4>
    <div class="card-detail-list d-flex flex-column">
      <div
        class="card-detail-item d-flex align-items-center justify-content-between"
      >
        <div class="content">
          <h5 class="mb-2">Quick Booking</h5>
          <p>
            Choose one of our trusted dentists and request an appointment at a
            time convenient to you
          </p>
        </div>
        <div class="icon d-flex align-items-center justify-content-center">
          <i class="sh-calendar"></i>
        </div>
      </div>
      <div
        class="card-detail-item d-flex align-items-center justify-content-between"
      >
        <div class="content">
          <h5 class="mb-2">Exclusive Deals</h5>
          <p>
            Select a dentist locally and discover exclusive discounts curated
            for Smilo members.
          </p>
        </div>
        <div class="icon d-flex align-items-center justify-content-center">
          <i class="sh-badge-discount"></i>
        </div>
      </div>
      <div
        class="card-detail-item d-flex align-items-center justify-content-between"
      >
        <div class="content">
          <h5 class="mb-2">Personalised Care</h5>
          <p>
            Our dentists will review your report and create a personalized care
            plan for you.
          </p>
        </div>
        <div class="icon d-flex align-items-center justify-content-center">
          <i class="sh-shopping-basket-heart"></i>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary btn-rounded-corner btn-icon-right btn-lg mx-auto mt-3"
      (click)="onBookNow()"
    >
      Request Appointment <i class="icon_arrow icon-right-arrow"></i>
    </button>
  </div>
</div>

<!-- Teeth Whitening start -->
<div *ngIf="isTeethWhiteningResult">
  <div class="next-card-header">
    <div class="next-card-top d-flex align-items-center justify-content-between">
      <div class="card-content">
        <h4>Get a Dental Check now</h4>
        <!-- <h4>Request A Dental Appointment</h4> -->
        <p>
          Get a personalised dental check report in less than 3 minutes with a few mouth selfies
        </p>
        <!-- <p>Secure your next appointment with ease & enhance your smile.</p> -->
        <button class="btn btn-primary btn-rounded-corner btn-icon-right btn-xs mt-2" (click)="checkNow()">
          Check now <i class="icon_arrow icon-right-arrow"></i>
        </button>
      </div>
      <div class="card-image">
        <img src="assets/images/appointment-card.png" class="img-fluid d-none d-sm-block" alt="" />
        <img src="assets/images/appointment-card-mobile.png" class="img-fluid d-block d-sm-none" alt="" />
      </div>
    </div>
    <div class="next-card-bottom">
      <a href="javascript:void(0)" class="d-flex align-items-center justify-content-center"
        (click)="isExpand = !isExpand"><b class="mr-1">Learn More</b> About Your Oral Health.
        <i class="ml-2" [ngClass]="!isExpand ? 'sh-angle-down' : 'sh-angle-up'"></i></a>
    </div>
  </div>
  <div class="next-card-body" *ngIf="isExpand">
    <h4>All Benefits</h4>
    <div class="card-detail-list d-flex flex-column">
      <div class="card-detail-item d-flex align-items-center justify-content-between">
        <div class="content">
          <h5 class="mb-2">Quick Booking</h5>
          <p>
            Choose one of our trusted dentists and request an appointment at a
            time convenient to you
          </p>
        </div>
        <div class="icon d-flex align-items-center justify-content-center">
          <i class="sh-calendar"></i>
        </div>
      </div>
      <div class="card-detail-item d-flex align-items-center justify-content-between">
        <div class="content">
          <h5 class="mb-2">Exclusive Deals</h5>
          <p>
            Select a dentist locally and discover exclusive discounts curated
            for Smilo members.
          </p>
        </div>
        <div class="icon d-flex align-items-center justify-content-center">
          <i class="sh-badge-discount"></i>
        </div>
      </div>
      <div class="card-detail-item d-flex align-items-center justify-content-between">
        <div class="content">
          <h5 class="mb-2">Personalised Care</h5>
          <p>
            Our dentists will review your report and create a personalized care
            plan for you.
          </p>
        </div>
        <div class="icon d-flex align-items-center justify-content-center">
          <i class="sh-shopping-basket-heart"></i>
        </div>
      </div>
    </div>
    <button class="btn btn-primary btn-rounded-corner btn-icon-right btn-lg mx-auto mt-3" (click)="onBookNow()">
      Request Appointment <i class="icon_arrow icon-right-arrow"></i>
    </button>
  </div>
</div>
